import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const ChevronLeft = ({
  color = colors.primary,
  isInverted = false,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps & { isInverted?: boolean }) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg width={size} height={size} viewBox="0 0 44 44" fill="none">
          <path
            d="M26.2501 12.5001L16.5002 22.25L26.2501 31.9999"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 44 44" fill="none" {...props}>
      <Path
        d="M26.2501 12.5001L16.5002 22.25L26.2501 31.9999"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
